import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { HEADER, NAVBAR } from './config';
import DashboardHeader from './layouts/header';
import NavbarVertical from './layouts/navbar/NavbarVertical';
import Router from './routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NotificationsProvider } from './contexts/NotificationsContext';

const MainStyle = styled('main')(({ theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT + 24,
  paddingBottom: HEADER.MOBILE_HEIGHT + 24,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter
    }),
    marginLeft: NAVBAR.DASHBOARD_WIDTH
  }
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  return (
    <NotificationsProvider>
      <DashboardHeader
        onOpenSidebar={() => setOpen(true)}
        verticalLayout={true}
      />

      <NavbarVertical
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />

      <MainStyle>
        <Router />
      </MainStyle>

      <ToastContainer />
    </NotificationsProvider>
  );
}
